import DriverPlanAcceptRequest from "../../../../api/raily/driver/plan/accept/driver-plan-accept.request";
import DriverPlanAcceptParams from "./driver-plan-accept-params";

const create = (params: DriverPlanAcceptParams): DriverPlanAcceptRequest => {
  return {
    driverUuid: params.driverUuid,
  };
};

const driverPlanAcceptParamsFactory = {
  create,
};

export default driverPlanAcceptParamsFactory;
